import React from 'react';
import SEO from '../components/common/SEO';
import AboutHeroSection from '../components/about/AboutHeroSection';
import AboutStatsSection from '../components/about/AboutStatsSection';
import AboutWhySection from '../components/about/AboutWhySection';
import AboutStrategySection from '../components/about/AboutStrategySection';
import AboutMoreThanSection from '../components/about/AboutMoreThanSection';

const About = () => {
  return (
    <main className="w-full bg-[#f9f9f5] min-h-screen">
      <SEO
        title="About Princy Patel"
        description="Meet Princy Patel, founder and web designer at SeaSalt Creative. Crafting elevated, high-converting websites tailored for creative service providers and wellness brands."
        keywords="princy patel, princy, web designer princy patel, about seasalt creative, brand designer, creative studio, showit website designer"
      />
      <AboutHeroSection />
      <AboutStatsSection />
      <AboutWhySection />
      <AboutStrategySection />
      <AboutMoreThanSection />
    </main>
  );
};

export default About;
